import React from 'react';
import PropTypes from 'prop-types';
//
import styles from './brand.scss';

export const Brand = ({
  brand,
}) => {
  if (!brand) return null;

  if (brand === 'John Lewis ANYDAY') {
    return <h4>John Lewis <span className={styles.anyday}>ANYDAY</span></h4>;
  }

  return <h4>{ brand }</h4>;
};

Brand.propTypes = {
  brand: PropTypes.string,
};

export default Brand;
